<template>
  <div class="top">
    <div class="wapper w116 topmennu">
      <img src="@/assets/images/managerlogo.png" class="logo" @click="managerhome" />
      <ul>
        <li @click="managerhome" class="checked">首页</li>
        <li @click="toResources">资源中心</li>
        <li @click="toknowledge">知识中心</li>
        <li @click="toBookCenter">资讯及书展</li>
        <li @click="toSphome">机构采选</li>
        <li @click="toPay">支付服务</li>
      </ul>
      <!-- <p @click="toSphome">机构采选</p> -->
      <div class="login-wrapper">
        <div v-if="isLogin" class="login">
          <span @click="toCenter">个人中心</span>
          <span class="line">|</span>
          <span @click="confirmLogout">退出</span>
        </div>
        <div v-else class="login">
          <span @click="doLogin">登录</span>
          <span class="line">|</span>
          <span @click="doSignUp">注册</span>
        </div>
        <login-menu :showLogin="showLogin" :tab="loginTab" @close-dialog="closeDialog" />
      </div>
    </div>
    <div class="w700">
      <img src="@/assets/images/home-title.png" class="title-img" />
      <div class="search">
        <el-input
          class="search-input"
          placeholder="请输入关键词"
          v-model="keyword"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <button class="search-button" @click="toSearch()" id="searchbutton"></button>
      </div>
    </div>
  </div>
</template>

<script>
import loginMenu from '@/views/top/LoginMenu.vue'
import urlSet from '@/utils/url'

export default {
  name: 'HomeHeader',
  components: {
    loginMenu,
  },
  props: {},
  data() {
    return {
      keyword: '',
      customercode: '',
      showLogin: false,
      loginTab: 0,
    }
  },
  computed: {
    isLogin() {
      const token = localStorage.getItem('token')
      if (token) return true
      else return false
    },
  },
  methods: {
    doLogin() {
      this.loginTab = 0
      this.showLogin = true
    },
    doSignUp() {
      this.loginTab = 1
      this.showLogin = true
    },
    closeDialog() {
      this.showLogin = false
    },
    // 确认是否退出
    confirmLogout() {
      this.$confirm('确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.doLogout()
        })
        .catch(() => {
          return false
        })
    },
    doLogout() {
      this.$http.get('/api/v1/user/accountlogout').then(res => {
        if (res.cxajaxrc == 0) {
          this.$message.success('您已成功退出')
          localStorage.clear()
          location.reload()
        }
      })
    },
    toCenter() {
      window.open('/my/#/')
    },
    toSearch() {
      if (this.keyword.substring(0, 3) === '978') {
        this.keyword = this.lodash.replace(this.keyword, /-/g, '')
      }
      sessionStorage.setItem('keyword', this.keyword)
      const { href } = this.$router.resolve({
        path: '/searchresult',
        query: {
          searchword: this.keyword,
        },
      })
      //this.$router.push(href)
      window.open(href)
    },
    managerhome() {
      location.href = '/index/#/managerhome'
      // if (this.$route.path === '/managerhome') {
      //   location.reload()
      // }
      // this.$router.push('/managerhome')
    },
    toResources() {
      window.location.href = '/dc/#/home'
    },
    toSphome() {
      window.open(urlSet.baseUrl + '/xs/#/sphome')
    },
    toPay() {
      window.location.href = '/index/#/pay'
    },
    getLibraryConfigByShortName(shortname) {
      this.$http({
        url: `/api/v1/login/getCustomerLoginCofig?shortName=${shortname}`,
        method: 'GET',
      }).then(res => {
        if (res.cxajaxrc == 0) {
          let customerConfig = res.returnvalue
          localStorage.setItem('CustomerLoginCofig', JSON.stringify(customerConfig))
        }
      })
    },
    toBookCenter() {
      window.location.href = '/ic/#/ibhome'
    },
    toknowledge() {
      window.location.href = '/kc/#/home'
    },
  },
  created() {
    this.customercode = localStorage.getItem('customerCode')
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  height: 400px;
  opacity: 1;
  background: url(../assets/images/home-background.png);
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  .topmennu {
    line-height: 45px;
    color: #333;
    display: flex;
    .logo {
      max-height: 60px;
      margin: 6px 0px;
      cursor: pointer;
    }
    ul {
      display: flex;
      align-items: center;
      height: 45px;
      margin-left: 180px;
      li {
        width: auto;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
        margin-right: 25px;
        position: relative;
        &::before,
        &::after {
          content: ''; /*单引号双引号都可以，但必须是英文*/
          width: 0;
          height: 2px; /*下划线高度*/
          background: #555; /*下划线颜色*/
          position: absolute;
          top: 100%;
          left: 35%;
        }
        &:hover:before {
          /*动画效果是从中间向左延伸至50%的宽度*/
          width: 20px;
        }
      }
      .checked {
        color: #333;
        width: 36px;
        position: relative;
        &::after {
          content: ' ';
          width: 20px;
          height: 2px;
          background: #555;
          position: absolute;
          bottom: -0.1rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    > p {
      cursor: pointer;
      font-size: 18px;
      height: 45px;
    }
    > p:hover {
      border-bottom: 2px solid #333;
    }
    > div {
      margin-left: auto;
    }
  }
}
.w700 {
  width: 700px;
  margin: 0px auto;
  .title-img {
    margin-top: 30px;
  }
  .search {
    margin-top: 33px;
    display: flex;
    /deep/ .el-input--suffix .el-input__inner,
    .el-input {
      width: 615px;
      height: 60px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 16px;
      ::placeholder {
        //通过这个设置
        color: #bbbbbb !important; //如果有时不生效 有可能是权限不够 加一个!important 即可
      }
    }
    .search-button {
      background: url(../assets/images/searchicon.png);
      width: 80px;
      height: 60px;
      cursor: pointer;
    }
  }
}
.w116 {
  width: 1160px;
  margin: 0px auto;
}
.manager {
  /deep/ span {
    color: #333 !important;
  }
  /deep/ .logout {
    color: #333 !important;
  }
  /deep/ .el-dialog {
    .el-button--primary {
      span {
        color: #fff !important;
      }
    }
  }
}
.login-wrapper {
  .login {
    line-height: 45px;
    span {
      cursor: pointer;
    }
    .line {
      margin: 0 5px;
      padding: 0 5px;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeHeader.vue